import React, { Fragment } from 'react';
import { Row, Col } from 'reactstrap';
import { CustomFormInput } from '../../../../utils';
import { FormattedNumber } from '../../../FormattedNumber/FormattedNumber';

const CustodyLock = ({ info }) => {
  return (
    <Fragment>
      <Row>
        <Col xs={6} md={4} lg={3}>
          <CustomFormInput label="Account">
            {info.accountName} - {info.accountNumber}
          </CustomFormInput>
        </Col>
       
        <Col xs={6} md={4} lg={3}>
          <CustomFormInput label="Ticker">
            {info.assetticker}
          </CustomFormInput>
        </Col>

        <Col xs={6} md={4} lg={3}>
          <CustomFormInput label="Volume">
            <FormattedNumber value={info.volume} dataTypeDecimalName="currency"/>
          </CustomFormInput>
        </Col>

        <Col xs={6} md={4} lg={3}>
          <CustomFormInput label="Status">
            {info.internalstatus}
          </CustomFormInput>
        </Col>

        <Col xs={6} md={4} lg={3}>
          <CustomFormInput label="Ext. Status">
            {info.externalstatus}
          </CustomFormInput>
        </Col>
        
        <Col xs={6} md={4} lg={4}>
          <CustomFormInput label="Type">
            {info.type}
          </CustomFormInput>
        </Col>
      </Row>
    </Fragment>
  );
};

export default CustodyLock;